import react from "react";
import { Th } from "../components/Table/index.js";
function getHeaderColumnCount(children) {
    let headerColumnCount = 0;
    react.Children.forEach(children, (child)=>{
        if (react.isValidElement(child) && (child.type === Th || 'th' === child.type)) headerColumnCount++;
    });
    return headerColumnCount;
}
export { getHeaderColumnCount };
